import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'
import { CHAIN_ID } from './networks'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'BUSD/WBNB LP',
    isHelperPrice: true,
    lpAddresses: {
      12301: '0xDE45FD3938992C1f4E5f2513Bf47c2fC61C7f47C',
      12302: '0xDE45FD3938992C1f4E5f2513Bf47c2fC61C7f47C',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.cake,
    rewardTokenList: ''
  },
  {
    pid: 1,
    lpSymbol: 'CTC/USDT LP',
    isHelperPrice: true,
    lpAddresses: {
      12301: '0xDE45FD3938992C1f4E5f2513Bf47c2fC61C7f47C',
      12302: '0xDE45FD3938992C1f4E5f2513Bf47c2fC61C7f47C',
    },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.cake,
    rewardTokenList: ''
  }
].filter((f) => !!f.lpAddresses[CHAIN_ID])

export default farms
